module.exports = __webpack_public_path__ + "static/media/pause_black.c2edc8ea.svg";